import type { UseQueryOptions } from "@tanstack/react-query";
import { useQuery } from "@tanstack/react-query";
import { apiWithoutCamelization } from "../../../../../api";
import urls from "../../../../../urls";
import type { GridFees } from "../DeliveryModal.types";

export enum GridUsageBillingModel {
  SLP = "slp",
  RLM = "rlm"
}

export function useGridFees(
  siteId: number | null | undefined,
  gridUsageBillingModel: GridUsageBillingModel | undefined,
  options?: Partial<UseQueryOptions<GridFees | null>>
) {
  const {
    isLoading: isGridFeesDataLoading,
    error: gridFeesLoadingError,
    data: gridFees
  } = useQuery({
    queryKey: ["gridFees", { siteId, gridUsageBillingModel }],
    queryFn: () => fetchGridFees(siteId, gridUsageBillingModel),
    enabled: !!siteId,
    gcTime: 0,
    refetchInterval: false,
    refetchOnWindowFocus: false,
    retry: 1,
    ...options
  });

  return {
    isGridFeesDataLoading,
    gridFeesLoadingError,
    gridFees
  };
}

async function fetchGridFees(
  siteId: number | undefined | null,
  gridUsageBillingModel: GridUsageBillingModel | undefined
) {
  if (!siteId || !gridUsageBillingModel) {
    return null;
  }

  const endpointUrl =
    gridUsageBillingModel === GridUsageBillingModel.RLM
      ? urls.apiWithoutCamelization.rlmGridFees(siteId)
      : urls.apiWithoutCamelization.slpGridFees(siteId);
  const response = await apiWithoutCamelization.get<GridFees>(endpointUrl);

  return response.data;
}
